import styled from "styled-components"

const Footer = styled.div`
  width: 100%;
  margin-top: auto;
`

export default Footer
